import { useEffect, useMemo, useRef, useState } from 'react';
import './index.scss';
import { PiCaretDownBold } from 'react-icons/pi';
import img from '../../assets/icons/TargetSavings.svg';

import { ModalFormActionProps, QuickActionProps, QuickActionsGroup } from '../../types';
import ModalSuccess from '../Modals/ModalSuccess';
import ModalAction from '../Modals/ModalAction';
import { Alert } from '@piggytechng/component-library';
import ModalChangeRentDate from '../Modals/HouseMoney/ModalChangeRentDate';
import ModalFixInterest from '../Modals/HouseMoney/ModalFixInterest';
import ModalFlexDollarFixInterest from '../Modals/FlexDollar/ModalFixInterest';
import ModalGeneralExecution from '../Modals/ModalGeneralExecution';
import ModalCreditPiggypoint from '../Modals/ModalCreditPiggypoint';
import ModalDebitPiggypoint from '../Modals/ModalDebitPiggypoint';
import { HiOutlinePlus } from 'react-icons/hi';
import ModalExecuteAction from '../Modals/ModalExecuteAction';
import { MdOutlineEditCalendar } from 'react-icons/md';
import { GrRefresh, GrUpdate } from 'react-icons/gr';
import { IoCashOutline } from 'react-icons/io5';
import useTargetSavings from '../../hooks/useTargetSavings';
import ModalAdminAction from '../Modals/ModalAdminAction';
import { TbEdit } from 'react-icons/tb';
import ModalChangeWithdrawalBank from '../Modals/ModalChangeWithdawalBank';
import useRolePermissions from '../../hooks/useRolePermissions';
import useCustomers from '../../hooks/useCustomers';
import ModalReverseAutosave from '../Modals/PiggyBank/ModalReverseAutosave';
import ModalDeleteTransactionQuick from '../Modals/ModalDeleteTransactionQuick';
import ModalGetItAction from '../Modals/ModalGetItAction';
import ModalInvestifyAction from '../Modals/ModalInvestifyAction';
import useGetIt from '../../hooks/useGetIt';
import useInvestify from '../../hooks/useInvestify';

const index = ({
  activeTabWallet = 'flexnaira',
  targetStatus,
  userId,
  targetId,
  activeGetItTab,
  activeInvestmentTab,
}: QuickActionProps) => {
  const { restrictActionByRole, canPerformAction, inviteAdmin, isSuperAdmin } = useRolePermissions({});

  const canChangeHousemoneyEndDate = canPerformAction('housemoney', 'changeEndDate');
  const canFixHousemoneyInterest = canPerformAction('housemoney', 'fixInterest');
  const canPayFlexNairaInterestByDay = canPerformAction('flexnaira', 'payInterestByDay');
  const canPayTargetInterest = canPerformAction('target', 'payInterest');
  const { adjustSubscriptionWallet, isPerformingAction } = useGetIt();
  const { reconcileInvestment, isLoading: isReconcilingInvestify } = useInvestify();

  const { fixWalletBalance } = useCustomers();

  const [showDropdown, setShowDropdown] = useState(false);
  const [showSuccessModal, setshowSuccessModal] = useState(false);
  const [showActionModal, setShowActionModal] = useState(false);
  const [actionIsLoading, setActionIsLoading] = useState(false);
  const [showExecuteAction, setShowExecuteAction] = useState(false);
  const [showGeneralExecution, setShowGeneralExecution] = useState(false);
  const [showHMChangeRentDate, setShowHMChangeRentDate] = useState(false);
  const [showHMFixInterest, setShowHMFixInterest] = useState(false);
  const [showFDFixInterest, setShowFDFixInterest] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const [creditPointModal, setCreditPointModal] = useState(false);
  const [debitPointModal, setDebitPointModal] = useState(false);
  const { runTargetAction } = useTargetSavings();
  const [modalInviteAction, showModalInviteAction] = useState(false);
  const [modalChangeWithdawalBank, showModalWithdrawalBank] = useState(false);
  const [showReverseAutosaveModal, setShowReverseAutosaveModal] = useState(false);
  const [showDeleteTransactionModal, setShowDeleteTransactionModal] = useState(false);
  const [showGetItActionModal, setShowGetItActionModal] = useState(false);
  const [showInvestifyActionModal, setShowInvestifyActionModal] = useState(false);
  const [getItActionProps, setGetItActionProps] = useState<{
    title: string;
    action: (payload: any) => void;
  }>({
    title: '',
    action: () => {},
  });

  const [investifyActionProps, setInvestifyActionProps] = useState<{
    title: string;
    action: (payload: any) => void;
  }>({
    title: '',
    action: () => {},
  });

  const [execution, setExecution] = useState({
    text: '',
    action: (password?: string) => console.log('i am executed', !!password),
    actionColor: '',
    buttonText: 'Execute',
    type: '',
    allowRender: activeTabWallet === 'housemoney' ? true : false,
  });

  const [formActionProps, setFormActionProps] = useState<ModalFormActionProps>({
    context: 'target',
    action: 'change-end-date',
  });

  const quickActionsGroup: QuickActionsGroup = useMemo(() => {
    return {
      housemoney: {
        actions: [
          {
            img: img,
            isActive: true,
            title: 'Change End Date',
            hide: !canChangeHousemoneyEndDate,
            action: () => {
              if (restrictActionByRole('housemoney', 'changeEndDate')) return;

              setShowHMChangeRentDate(true);
              setExecution((prev) => ({
                ...prev,
                text: 'Change End Date',
                action: () => {
                  Alert.success('End date changed successfully');
                },
                buttonText: 'Change Date',
                actionColor: '#F37932',
                allowRender: true,
              }));
            },
          },
          {
            img: img,
            isActive: true,
            title: 'Fix Interest',
            hide: !canFixHousemoneyInterest,
            action: () => {
              if (restrictActionByRole('housemoney', 'fixInterest')) return;

              setShowHMFixInterest(true);
              setExecution((prev) => ({
                ...prev,
                text: 'Fix Interest',
                action: () => {
                  Alert.success('Interest fixed successfully');
                },
                buttonText: 'Change Date',
                actionColor: '#F37932',
                allowRender: true,
              }));
            },
          },
          {
            img: img,
            isActive: true,
            title: 'Fix Account Balance',
            action: () => {
              if (restrictActionByRole('housemoney', 'fixUsersBalance')) return;

              setShowGeneralExecution(true);
              setExecution((prev) => ({
                ...prev,
                text: 'fix Account Balance',
                action: () => {
                  Alert.success('Interest fixed successfully');
                },
                buttonText: 'Change Date',
                actionColor: '#F37932',
                type: 'fix_account_balance',
              }));
            },
          },
          {
            img: img,
            isActive: true,
            title: 'Generate Account Number',
            action: () => {
              setShowGeneralExecution(true);
              setExecution((prev) => ({
                ...prev,
                text: 'generate a new Account Number',
                action: () => {},
                buttonText: 'Change Date',
                actionColor: '#F37932',
                type: 'generate_hm_nuban',
              }));
            },
          },
        ],
      },
      target: {
        actions: [
          ...(targetStatus === 0
            ? [
                {
                  img: <MdOutlineEditCalendar />,
                  isActive: true,
                  title: 'Change Start Date',
                  action: () => {
                    if (restrictActionByRole('target', 'changeStartDate')) return;
                    setShowActionModal(true);
                    setFormActionProps({
                      title: 'Change Start Date',
                      context: 'target',
                      action: 'update-start-date',
                      buttonText: 'Change Date',
                      actionColor: '#00896B',
                      isLoading: false,
                    });
                  },
                },
                {
                  img: <MdOutlineEditCalendar />,
                  isActive: true,
                  title: 'Change End Date',
                  action: () => {
                    if (restrictActionByRole('target', 'changeEndDate')) return;
                    setShowActionModal(true);
                    setFormActionProps({
                      title: 'Change End Date',
                      context: 'target',
                      action: 'update-end-date',
                      buttonText: 'Change Date',
                      actionColor: '#00896B',
                      isLoading: false,
                    });
                  },
                },

                {
                  img: <GrUpdate />,
                  isActive: true,
                  title: 'Update Frequency',
                  action: () => {
                    if (restrictActionByRole('target', 'updateFrequency')) return;

                    setShowActionModal(true);
                    setFormActionProps({
                      title: 'Change End Date',
                      context: 'target',
                      action: 'update-frequency',
                      buttonText: 'Update',
                      actionColor: '#00896B',
                      isLoading: false,
                    });
                  },
                },
              ]
            : [
                {
                  img: <GrRefresh />,
                  isActive: true,
                  title: 'Rejoin Target',
                  action: () => {
                    if (restrictActionByRole('target', 'rejoinTarget')) return;
                    setShowExecuteAction(true);
                    setExecution((prev) => ({
                      ...prev,
                      text: 'Rejoin Target',
                      action: (password?: string) => {
                        handleActions('target', { action: 'join-target', userId, password });
                      },
                      buttonText: 'Change Date',
                      actionColor: '#00896B',
                      allowRender: true,
                    }));
                  },
                },
                {
                  img: <IoCashOutline />,
                  isActive: false,
                  title: 'Pay interest',
                  hide: !canPayTargetInterest,
                  action: () => {
                    if (restrictActionByRole('target', 'payInterest')) return;
                  },
                },
              ]),
        ],
      },
      piggybank: {
        actions: [
          {
            img: img,
            isActive: false,
            title: 'Delete Last Interest',
            action: () => {
              if (restrictActionByRole('piggybank', 'payInterestByMonth')) return;
              setShowActionModal(true);
              setExecution((prev) => ({
                ...prev,
                text: 'Delete Last Interest',
                action: () => {
                  Alert.success('Reversed multiple autosave successfully');
                },
                buttonText: 'Reverse',
                actionColor: '#1734CA',
              }));
            },
          },
          {
            img: img,
            isActive: true,
            title: 'Reverse Multiple Autosave',
            action: () => {
              if (restrictActionByRole('piggybank', 'reverseMultipleAutosaves')) return;
              setShowReverseAutosaveModal(true);
            },
          },
          {
            img: img,
            isActive: true,
            title: 'Fix wallet Balance',
            action: () => {
              if (restrictActionByRole('piggybank', 'fixWalletBalance')) return;

              setShowExecuteAction(true);
              setExecution((prev) => ({
                ...prev,
                text: 'fix wallet Balance',
                action: () => {
                  setActionIsLoading(true);
                  fixWalletBalance('piggybank').finally(() => {
                    setActionIsLoading(false);
                  });
                },
                buttonText: 'Change Date',
                actionColor: '#1734CA',
              }));
            },
          },
          {
            img: img,
            isActive: true,
            title: 'Delete Transaction',
            action: () => {
              if (restrictActionByRole('piggybank', 'deleteTransaction')) return;
              setShowDeleteTransactionModal(true);
            },
          },
        ],
      },
      getit: {
        actions: [
          ...(activeGetItTab !== 'completed'
            ? [
                {
                  img: <HiOutlinePlus />,
                  isActive: true,
                  title: 'Add Money',
                  action: () => {
                    setGetItActionProps({
                      title: 'Add Money',
                      action: (payload: any) => {
                        adjustSubscriptionWallet(
                          userId as string,
                          targetId as string,
                          {
                            ...payload,
                            type: 'credit',
                          },
                          () => setShowGetItActionModal(false),
                        );
                      },
                    });
                    setShowGetItActionModal(true);
                  },
                },
                {
                  img: <IoCashOutline />,
                  isActive: true,
                  title: 'Withdraw Money',
                  action: () => {
                    setGetItActionProps({
                      title: 'Withdraw Money',
                      action: (payload: any) => {
                        adjustSubscriptionWallet(
                          userId as string,
                          targetId as string,
                          {
                            ...payload,
                            type: 'debit',
                          },
                          () => setShowGetItActionModal(false),
                        );
                      },
                    });
                    setShowGetItActionModal(true);
                  },
                },
              ]
            : [
                {
                  img: <IoCashOutline />,
                  isActive: true,
                  title: 'Refund',
                  action: () => {
                    setGetItActionProps({
                      title: 'Are you sure you want to refund?',
                      action: (payload: any) => {
                        adjustSubscriptionWallet(
                          userId as string,
                          targetId as string,
                          {
                            ...payload,
                            type: 'debit',
                            reason: 'Refund request',
                          },
                          () => setShowGetItActionModal(false),
                        );
                      },
                    });
                    setShowGetItActionModal(true);
                  },
                },
              ]),
        ],
      },
      investify: {
        actions: [
          ...(activeInvestmentTab !== 'completed'
            ? [
                {
                  img: <IoCashOutline />,
                  isActive: true,
                  title: 'Debit Investment',
                  action: () => {
                    setInvestifyActionProps({
                      title: 'Debit Investment',
                      action: (payload: any) => {
                        reconcileInvestment(userId as string, targetId as string, payload, () =>
                          setShowInvestifyActionModal(false),
                        );
                      },
                    });
                    setShowInvestifyActionModal(true);
                  },
                },
              ]
            : []),
        ],
      },
      safelock: {
        actions: [],
      },
      // flags: {
      //   actions: [
      //     {
      //       img: <HiOutlinePlus />,
      //       isActive: true,
      //       title: 'Flag User',
      //       action: () => {
      //         if (restrictActionByRole('flagAndActions', 'flagAction')) return;
      //         setShowActionModal(true);
      //         setFormActionProps({
      //           title: 'Flag User',
      //           context: 'user',
      //           action: 'flagUser',
      //           buttonText: 'Flag User',
      //           actionColor: '#FF4D4F',
      //           isLoading: false,
      //         });
      //       },
      //     },
      //     {
      //       img: <HiOutlinePlus />,
      //       isActive: true,
      //       title: 'Unflag User',
      //       action: () => {
      //         if (restrictActionByRole('flagAndActions', 'unflagAction')) return;
      //         setShowActionModal(true);
      //         setFormActionProps({
      //           title: 'Unflag User',
      //           context: 'user',
      //           action: 'unflagUser',
      //           buttonText: 'Unflag User',
      //           actionColor: '#00896B',
      //           isLoading: false,
      //         });
      //       },
      //     },
      //   ],
      // },
      flexnaira: {
        actions: [
          // Disabled until a core endpoint exists: the old handlers only showed a success toast
          // without calling any API, which read as "interest paid" to ops.
          {
            img: img,
            isActive: false,
            title: 'Pay Interest by Month (coming soon)',
            action: () => {
              if (restrictActionByRole('flexnaira', 'payInterestByMonth')) return;
              setShowExecuteAction(true);
              setExecution((prev) => ({
                ...prev,
                text: 'pay interest by month',
                action: () => {
                  Alert.success('Interest paid successfully');
                },
                buttonText: 'Pay Interest',
                actionColor: '#1734CA',
              }));
            },
          },
          {
            img: img,
            isActive: false,
            title: 'Pay Interest by Day (coming soon)',
            hide: !canPayFlexNairaInterestByDay,
            action: () => {
              if (restrictActionByRole('flexnaira', 'payInterestByDay')) return;
              setShowExecuteAction(true);
              setExecution((prev) => ({
                ...prev,
                text: 'pay interest by day',
                action: () => {
                  Alert.success('Interest paid successfully');
                },
                buttonText: 'Pay Interest',
                actionColor: '#1734CA',
              }));
            },
          },
          {
            img: img,
            isActive: true,
            title: 'Fix Wallet balance',
            action: () => {
              if (restrictActionByRole('flexnaira', 'fixWalletBalance')) return;
              setShowExecuteAction(true);
              setExecution((prev) => ({
                ...prev,
                text: 'fix wallet balance',
                action: () => {
                  setActionIsLoading(true);
                  fixWalletBalance('flexnaira').finally(() => {
                    setActionIsLoading(false);
                  });
                },
                buttonText: 'Fix Balance',
                actionColor: '#1734CA',
              }));
            },
          },
          {
            img: img,
            isActive: true,
            title: 'Delete Transaction',
            action: () => {
              if (restrictActionByRole('flexnaira', 'deleteTransaction')) return;
              setShowDeleteTransactionModal(true);
            },
          },
          {
            img: img,
            isActive: true,
            title: 'Generate Account Number',
            action: () => {
              if (restrictActionByRole('flexnaira', 'generateAccountNumber')) return;
              setShowGeneralExecution(true);
              setExecution((prev) => ({
                ...prev,
                text: 'generate a new Account Number',
                action: () => {},
                buttonText: 'Generate',
                actionColor: '#1734CA',
                type: 'generate_fn_nuban',
              }));
            },
          },
        ],
      },
      flexdollar: {
        actions: [
          {
            img: img,
            isActive: true,
            title: 'Fix Wallet Balance',
            action: () => {
              if (restrictActionByRole('flexdollar', 'fixWalletBalance')) return;
              if (!isSuperAdmin) {
                Alert.warn('You do not have access to perform this action.');
                return;
              }
              setShowExecuteAction(true);
              setExecution((prev) => ({
                ...prev,
                text: 'fix the Flex Dollar wallet balance',
                action: () => {
                  setActionIsLoading(true);
                  fixWalletBalance('flexdollar').finally(() => {
                    setActionIsLoading(false);
                    setShowExecuteAction(false);
                  });
                },
                buttonText: 'Fix Balance',
                actionColor: '#060F21',
              }));
            },
          },
          {
            img: img,
            isActive: true,
            title: 'Fix Interest',
            action: () => {
              if (restrictActionByRole('flexdollar', 'fixInterest')) return;
              if (!isSuperAdmin) {
                Alert.warn('You do not have access to perform this action.');
                return;
              }
              setShowFDFixInterest(true);
            },
          },
        ],
      },
      piggypoints: {
        actions: [
          {
            img: <HiOutlinePlus />,
            isActive: true,
            action: () => {
              if (restrictActionByRole('piggypoints', 'creditPoints')) return;
              setCreditPointModal(true);
            },
            title: 'Credit Piggypoints',
          },
          {
            img: <IoCashOutline />,
            isActive: true,
            action: () => {
              if (restrictActionByRole('piggypoints', 'debitPoints')) return;
              setDebitPointModal(true);
            },
            title: 'Debit Piggypoints',
          },
        ],
      },

      rolesAndPermissions: {
        actions: [
          {
            img: <HiOutlinePlus />,
            isActive: true,
            action: () => showModalInviteAction(true),
            title: 'Invite Admin',
          },
        ],
      },
      withdrawals: {
        actions: [
          // Disabled: ModalChangeWithdrawalBank only confirms and toasts, it never calls an API.
          {
            img: <TbEdit />,
            isActive: false,
            action: () => showModalWithdrawalBank(true),
            title: 'Change user withdrawal bank (coming soon)',
          },
        ],
      },
    };
  }, [
    targetStatus,
    userId,
    activeTabWallet,
    canChangeHousemoneyEndDate,
    canFixHousemoneyInterest,
    canPayFlexNairaInterestByDay,
    canPayTargetInterest,
  ]);

  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    if (showDropdown) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDropdown]);

  useEffect(() => {}, [execution.allowRender]);

  const handleActions = async (context: 'target' | 'invite-admin', payload: any, callback?: () => void) => {
    setActionIsLoading(true);

    if (context === 'target') {
      runTargetAction(targetId as string, payload, () => {
        setShowExecuteAction(false);
        setShowActionModal(false);
        if (callback) callback();
      }).finally(() => setActionIsLoading(false));
    }

    if (context === 'invite-admin') {
      inviteAdmin(payload).finally(() => {
        setActionIsLoading(false);
        setShowExecuteAction(false);
        setShowActionModal(false);
        if (callback) callback();
      });
    }
  };

  const visibleActions = quickActionsGroup[activeTabWallet]?.actions.filter((item) => !item.hide) ?? [];

  return (
    <>
      {quickActionsGroup[activeTabWallet] &&
        visibleActions.length > 0 &&
        (activeTabWallet !== 'target' || targetId) && (
          <div className={`quickActions ${activeTabWallet}`} ref={dropdownRef} key={activeTabWallet}>
            <div className="button flex--2" onClick={() => setShowDropdown(!showDropdown)}>
              <p>Quick Actions</p>
              <PiCaretDownBold fontSize={17} className="caret" />
            </div>
            {showDropdown && (
              <div className="dropdown flex--4">
                {visibleActions.map((item, i) => (
                  <div
                    key={i}
                    className={`details flex--2 pointer ${!item.isActive && 'is-not-active'}`}
                    onClick={() => {
                      setShowDropdown(false);
                      item.isActive && item.action?.(true);
                    }}
                  >
                    {typeof item.img === 'string' ? <img src={item.img} alt={item.title} /> : item.img}
                    <p>{item.title}</p>
                  </div>
                ))}
              </div>
            )}

            <ModalSuccess modalIsOpen={showSuccessModal} setIsOpen={setshowSuccessModal} />
            <ModalAction
              {...formActionProps}
              targetId={targetId}
              modalIsOpen={showActionModal}
              setIsOpen={setShowActionModal}
              isLoading={actionIsLoading}
            />

            <ModalExecuteAction
              modalIsOpen={showExecuteAction}
              setIsOpen={setShowExecuteAction}
              {...execution}
              isLoading={actionIsLoading}
            />

            <ModalGeneralExecution
              modalIsOpen={showGeneralExecution}
              setIsOpen={setShowGeneralExecution}
              {...execution}
              walletKey={activeTabWallet}
            />

            <ModalAdminAction
              modalIsOpen={modalInviteAction}
              isLoading={actionIsLoading}
              setIsOpen={showModalInviteAction}
              type={'invite-admin'}
              action={(payload) => {
                setExecution((prev) => ({
                  ...prev,
                  text: 'invite this admin account?',
                  action: () => {
                    handleActions('invite-admin', payload);
                  },
                  buttonText: 'Yes',
                  actionColor: '#1734CA',
                }));
                setShowExecuteAction(true);
                showModalInviteAction(false);
              }}
            />

            <ModalChangeWithdrawalBank
              modalIsOpen={modalChangeWithdawalBank}
              isLoading={actionIsLoading}
              setIsOpen={showModalWithdrawalBank}
              action={() => {
                setExecution((prev) => ({
                  ...prev,
                  text: 'update user withdrawal bank?',
                  action: () => {
                    Alert.success('User withdrawal bank changed');
                    setShowExecuteAction(false);
                  },
                  buttonText: 'Yes',
                  actionColor: '#1734CA',
                }));
                setShowExecuteAction(true);
                showModalWithdrawalBank(false);
              }}
            />

            <ModalChangeRentDate
              modalIsOpen={showHMChangeRentDate}
              setIsOpen={setShowHMChangeRentDate}
              {...execution}
            />
            <ModalFixInterest modalIsOpen={showHMFixInterest} setIsOpen={setShowHMFixInterest} {...execution} />
            <ModalFlexDollarFixInterest
              modalIsOpen={showFDFixInterest}
              setIsOpen={setShowFDFixInterest}
              allowRender={activeTabWallet === 'flexdollar'}
            />
            <ModalCreditPiggypoint modalIsOpen={creditPointModal} setIsOpen={setCreditPointModal} />
            <ModalDebitPiggypoint modalIsOpen={debitPointModal} setIsOpen={setDebitPointModal} />
            <ModalReverseAutosave
              modalIsOpen={showReverseAutosaveModal}
              setIsOpen={setShowReverseAutosaveModal}
              userId={userId || ''}
            />

            <ModalDeleteTransactionQuick
              modalIsOpen={showDeleteTransactionModal}
              setIsOpen={setShowDeleteTransactionModal}
              wallet={activeTabWallet === 'piggybank' ? 'piggybank' : 'flexnaira'}
            />

            <ModalGetItAction
              modalIsOpen={showGetItActionModal}
              setIsOpen={setShowGetItActionModal}
              {...getItActionProps}
              isLoading={isPerformingAction}
              activeGetItTab={activeGetItTab}
            />

            <ModalInvestifyAction
              modalIsOpen={showInvestifyActionModal}
              setIsOpen={setShowInvestifyActionModal}
              {...investifyActionProps}
              isLoading={isReconcilingInvestify}
            />
          </div>
        )}
    </>
  );
};

export default index;
